import React from 'react';

import { Button, ArrowIcon } from './scrollToTopButton.styles';

export const ScrollToTopButton = (props) => (
  <Button {...props}>
    <ArrowIcon />
    TOP
  </Button>
);
